module.exports = __webpack_public_path__ + "static/media/ck.1e91b28e.svg";